import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';

// Context
import { AuthProvider } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import { AppProvider } from './context/AppContext';

// Components
import Navigation from './components/Navigation';
import ProtectedRoute from './components/ProtectedRoute';

// Pages
import Login from './pages/Login';
import Stories from './pages/Stories';
import CreateStory from './pages/CreateStory';
import StoryDetail from './pages/StoryDetail';
import Studio from './pages/Studio';
import Apps from './pages/Apps';
import Analytics from './pages/Analytics';

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <AppProvider>
          <Router>
            <div className="App">
            <Navigation />
            <Container className="py-3">
              <Routes>
                {/* Public routes */}
                <Route path="/login" element={<Login />} />
                
                {/* Protected routes */}
                <Route element={<ProtectedRoute />}>
                  <Route path="/stories" element={<Stories />} />
                  <Route path="/create-story" element={<CreateStory />} />
                  <Route path="/story/:storyId" element={<StoryDetail />} />
                  <Route path="/story/:storyId/studio" element={<Studio />} />
                  <Route path="/apps" element={<Apps />} />
                  <Route path="/analytics" element={<Analytics />} />
                </Route>
                
                {/* Redirect to stories if authenticated, otherwise to login */}
                <Route path="/" element={<Navigate to="/stories" replace />} />
                
                {/* Catch all - redirect to stories */}
                <Route path="*" element={<Navigate to="/stories" replace />} />
              </Routes>
            </Container>
            </div>
          </Router>
        </AppProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
